import UserProductGroupErrorResponse from './UserProductGroupErrorResponse';

export const retryFetchAfterUserProductGroupLock = async <Response>(
	fetch: () => Promise<Response>,
	repeatInMilliseconds = 1000
): Promise<Response> => {
	const fetchWithRetry = async (): Promise<Response> => {
		try {
			return await fetch();
		} catch (error) {
			if ((error as UserProductGroupErrorResponse).handleProductGroupLocked()) {
				return new Promise((resolve) =>
					setTimeout(() => {
						resolve(fetchWithRetry());
					}, repeatInMilliseconds)
				);
			}
			throw error;
		}
	};

	return fetchWithRetry();
};
